// extracted by mini-css-extract-plugin
export default {"container":"tJbKw","divider":"JcV5b"};